/* unplugin-vue-components disabled */import { render } from "./LiveCard.vue?vue&type=template&id=1f18d153&scoped=true"
import script from "./LiveCard.vue?vue&type=script&lang=js"
export * from "./LiveCard.vue?vue&type=script&lang=js"

import "./LiveCard.vue?vue&type=style&index=0&id=1f18d153&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/外网-成都工业学院-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f18d153"]])

export default __exports__